import { SectionHeading } from './SectionHeading'

type Partner = {
  name: string
  category: string
  color: string
  bg: string
  url: string
}

const PARTNERS: Partner[] = [
  {
    name: 'インヴァスト証券株式会社',
    category: '金融・証券',
    color: '#2563eb',
    bg: 'rgba(37,99,235,0.08)',
    url: 'https://www.invast.jp/'
  },
  {
    name: '株式会社ストーンシステム',
    category: 'IT・システム',
    color: '#0891b2',
    bg: 'rgba(8,145,178,0.08)',
    url: 'https://www.stonesystem.co.jp/'
  },
  {
    name: '株式会社デジタルガレージ',
    category: 'デジタル・IT',
    color: '#7c3aed',
    bg: 'rgba(124,58,237,0.08)',
    url: 'https://www.garage.co.jp/'
  },
  {
    name: '株式会社Wellmira',
    category: 'ヘルスケア・IT',
    color: '#059669',
    bg: 'rgba(5,150,105,0.08)',
    url: 'https://www.wellmira.jp/'
  },
  {
    name: '株式会社エヌエムシイ',
    category: 'IT・サービス',
    color: '#d97706',
    bg: 'rgba(217,119,6,0.08)',
    url: 'https://nmc-ao.jp/'
  },
  {
    name: '共同印刷株式会社',
    category: '印刷・テクノロジー',
    color: '#db2777',
    bg: 'rgba(219,39,119,0.08)',
    url: 'https://www.kyodoprinting.co.jp/'
  },
  {
    name: 'ジョルダン株式会社',
    category: '交通・IT（親会社）',
    color: '#0d1f3c',
    bg: 'rgba(13,31,60,0.08)',
    url: 'https://www.jorudan.co.jp/'
  }
]

export function Partners() {
  return (
    <section
      id="partners"
      className="section-wrapper relative overflow-hidden bg-brand-gray"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-brand-gray via-white to-slate-100" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="Key Partners" title="主要取引先" />

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {PARTNERS.map((p, i) => (
            <a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`animate-on-scroll animate-on-scroll-delay-${(i % 4) + 1} relative bg-white rounded-2xl px-5 pt-5 pb-4 shadow-sm border border-slate-100 flex flex-col gap-3 overflow-hidden hover:shadow-md hover:border-slate-200 transition-all duration-300`}
            >
              {/* 左カラーボーダー */}
              <div
                className="absolute left-0 top-0 bottom-0 w-[3px] rounded-l-2xl"
                style={{ backgroundColor: p.color }}
              />
              <p className="text-brand-navy font-bold text-sm leading-snug flex-1">
                {p.name}
              </p>
              <div className="flex items-center gap-2">
                <span
                  className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                  style={{ backgroundColor: p.color }}
                />
                <span
                  className="text-[11px] font-semibold px-2.5 py-0.5 rounded-full"
                  style={{ backgroundColor: p.bg, color: p.color }}
                >
                  {p.category}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
